// extracted by mini-css-extract-plugin
module.exports = {"boxLeftx":"dev_boxLeftx__rpxRz","boxRightx":"dev_boxRightx__2s1Me","dflex":"dev_dflex__3KKfb"};